module.exports = __webpack_public_path__ + "img/busca-avancada-plantas-ornamentais-2.05faee2c.jpg";